// src/admin/components/HomePageConfig/ServicesSectionHeader.jsx
import React from "react";
import ColorSection from "./ColorSection";
import FontSizeSection from "./FontSizeSection";

export default function ServicesSectionHeader({ 
  servicesSection, 
  setServicesSection,
  servicesSectionColors,
  setServicesSectionColors 
}) {
  
  const handleColorChange = (property, value) => {
    setServicesSectionColors(prev => ({
      ...prev,
      [property]: value
    }));
  };

  const toggleSectionColors = (useSectionColors) => {
    setServicesSection(prev => ({
      ...prev,
      useSectionColors
    }));
  };

  const toggleSectionFontSizes = (useSectionFontSizes) => {
    setServicesSection((prev) => ({
      ...prev,
      useSectionFontSizes,
    }));
  };

  const handleFontSizeChange = (key, value) => {
    setServicesSection((prev) => ({
      ...prev,
      fontSizes: {
        ...(prev?.fontSizes || {}),
        [key]: value,
      },
    }));
  };

  return (
    <div className="hcfg-card">
      <div className="hcfg-headrow">
        <h3>Services Section Header</h3>
      </div>
      <div className="hcfg-row">
        <div className="hcfg-col">
          <label>Title</label>
          <input
            value={servicesSection.title}
            onChange={(e) =>
              setServicesSection((prev) => ({ ...prev, title: e.target.value }))
            }
            placeholder="e.g., One–stop shop for all things interiors"
          />
        </div>
        <div className="hcfg-col">
          <label>Description</label>
          <textarea
            rows={3}
            value={servicesSection.subtitle}
            onChange={(e) =>
              setServicesSection((prev) => ({
                ...prev,
                subtitle: e.target.value,
              }))
            }
            placeholder="e.g., Be it end-to-end interiors..."
          />
        </div>
      </div>

      {/* Color Customization for Services Section Header */}
      <ColorSection
        title="Services Section Header"
        colors={servicesSectionColors}
        onColorChange={handleColorChange}
        useSectionColors={servicesSection.useSectionColors !== false}
        onToggleSectionColors={toggleSectionColors}
      />

      <FontSizeSection
        title="Services Section Header"
        sizes={servicesSection.fontSizes || {}}
        onChange={handleFontSizeChange}
        useSectionFontSizes={servicesSection.useSectionFontSizes === true}
        onToggleSectionFontSizes={toggleSectionFontSizes}
        fields={[
          { key: "sectionTitle", label: "Title Size", placeholder: "e.g., 34px" },
          { key: "sectionDescription", label: "Description Size", placeholder: "e.g., 16px" },
        ]}
      />
    </div>
  );
}
